// This file contains optimizations for the website

// Optimize script loading
document.addEventListener('DOMContentLoaded', () => {
  // Defer non-critical resources
  const deferredScripts = document.querySelectorAll('script[data-defer="true"]');
  
  if ('requestIdleCallback' in window) {
    // Use requestIdleCallback for modern browsers
    window.requestIdleCallback(() => {
      deferredScripts.forEach(script => {
        const deferScript = document.createElement('script');
        deferScript.src = script.getAttribute('data-src') || '';
        document.body.appendChild(deferScript);
      });
    }, { timeout: 5000 });
  } else {
    // Fallback for browsers without requestIdleCallback
    setTimeout(() => {
      deferredScripts.forEach(script => {
        const deferScript = document.createElement('script');
        deferScript.src = script.getAttribute('data-src') || '';
        document.body.appendChild(deferScript);
      });
    }, 1000);
  }
  
  // Preconnect to external domains
  const preconnectDomains = [
    'https://randomuser.me',
    'https://via.placeholder.com',
    'https://fonts.googleapis.com',
    'https://fonts.gstatic.com'
  ];
  
  preconnectDomains.forEach(domain => {
    const link = document.createElement('link');
    link.rel = 'preconnect';
    link.href = domain;
    document.head.appendChild(link);
    
    // DNS prefetch as fallback
    const dnsLink = document.createElement('link');
    dnsLink.rel = 'dns-prefetch';
    dnsLink.href = domain;
    document.head.appendChild(dnsLink);
  });
});

// Optimize image loading
const observeAndLoadImages = () => {
  // Skip if IntersectionObserver is not supported
  if (!('IntersectionObserver' in window)) {
    return;
  }
  
  const imageObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target as HTMLImageElement;
        const src = img.getAttribute('data-src');
        
        if (src) {
          img.src = src;
          img.removeAttribute('data-src');
          observer.unobserve(img);
        }
      }
    });
  });
  
  // Target all images with data-src attribute
  const lazyImages = document.querySelectorAll('img[data-src]');
  lazyImages.forEach(img => {
    imageObserver.observe(img);
  });
};

// Run optimizations when window loads
window.addEventListener('load', () => {
  observeAndLoadImages();
});

// Export functions for use in React components
export const optimizations = {
  observeAndLoadImages
};

export default optimizations;
